<template>
  <div class="peimission-container">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" v-show="showSearch">
      <el-form-item label="名称" prop="operationName">
        <el-input
            v-model="queryParams.operationName"
            placeholder="请输入名称"
            clearable
            @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"  @click="handleQuery">搜索</el-button>
        <el-button  @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <el-row class="mb8">
      <el-col :span="1.5">
        <el-button
            type="primary"
            @click="handleAdd()"
            v-hasPermi="['system::permissionManage::add']"
        >
          新增
        </el-button>
      </el-col>
    </el-row>
    <!--&lt;!&ndash;      :tree-props="{children:'children',hasChildren:'hasChildren'}"&ndash;&gt;-->
    <!-- 数据表格 -->
    <el-scrollbar height="calc(100vh - 150px)">
      <el-table
          :data="allData"
          v-if="refreshTable"
          style="width:100%"
          border
          row-key="permissionId"
      >
        <el-table-column
            prop="permissionName"
            label="名称"
            width="180"
        >
        </el-table-column>
        <el-table-column
            prop="permissionCode"
            label="编码"
            width="200"
            align="center"
        >
        </el-table-column>
        <el-table-column
            prop="permissionDesc"
            label="描述"
            width="200"
            align="center"
        >
        </el-table-column>
        <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
          <template #default="scope">
            <el-button
                v-hasPermi="['system::permissionManage::distribution']"
                text
                type="primary"
                @click="handleDistribution(scope.row)"
            >
              分配操作
            </el-button>
            <el-button
                v-hasPermi="['system::permissionManage::update']"
                text
                type="primary"
                @click="handleUpdate(scope.row)"
            >
              修改
            </el-button>
            <el-button
                v-hasPermi="['system::permissionManage::delete']"
                text
                type="primary"
                @click="handleDelete(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-scrollbar>
    <!-- 添加活修改许可操作对话框 -->
    <el-dialog :title="title" v-model="dialogOpen" width="600px" append-to-body>
      <el-form ref="dialogFormRef" :model="dialogFormData" :rules="dialogFormRules" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="名称" prop="permissionName">
              <el-input  v-model="dialogFormData.permissionName" placeholder="请输入名称"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="编码" prop="permissionCode">
              <el-input  v-model="dialogFormData.permissionCode	" placeholder="请输入编码"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="描述" prop="permissionDesc">
              <el-input  v-model="dialogFormData.permissionDesc" placeholder="请输入描述"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closed">{{ $t('msg.universal.cancel') }}</el-button>
          <el-button type="primary" @click="onConfirm">{{ $t('msg.universal.confirm') }}</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 分配操作对话框 -->
    <el-dialog :title="distributeDialogTitle" v-model="distributeDialogOpen"
               width="500px" append-to-body>
      <el-form :model="distributeDataForm" label-width="80px">
        <el-form-item label="许可名称">
          <el-input v-model="distributeDataForm.permissionName" :disabled="true"/>
        </el-form-item>
        <el-form-item label="操作权限">
          <el-scrollbar height="400px">
            <el-tree
                class="tree-border"
                :data="operationOptions"
                show-checkbox
                default-expand-all
                ref="operationTreeRef"
                node-key="operationId"
                empty-text="加载中，请稍等"
                :props="distributeProps"></el-tree>
          </el-scrollbar>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closedDistribute">{{ $t('msg.universal.cancel') }}</el-button>
          <el-button type="primary" @click="onConfirmDistribute">{{ $t('msg.universal.confirm') }}</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import {getCurrentInstance, ref} from "vue";
import {watchSwitchLang} from "@/utils/i18n";
import {addOperation, getOperation, modifyPermission, removePermission, savePermission} from "@/api/system/peimission";
// import {useStore} from "vuex";
import useSystemStore from '@/store/modules/system'
import {joinComma} from "@/utils/stringutil";
// import {saveRole} from "@/api/system/role";
import {warnMsg,confirmBox,succesMsg} from "@/utils/msgBox.ts"
const store = useSystemStore()

const {proxy, appContext} = getCurrentInstance()
defineOptions({
    name: "permissionManage",
  })

// 查询参数
const queryParams = ref({
  operationName: ''
})
const allData = ref([])
// 是否显示搜索
const showSearch = ref(false)
// 刷新表格
const refreshTable = ref(true)
// 查询
const handleQuery = async () => {
  await store.getAllPermission(true).then(resData => {
    allData.value = resData
  })
}
// 重置
const resetQuery = () => {

}

handleQuery()
watchSwitchLang(handleQuery)

// 添加
const handleAdd = () => {
  dialogReset() // 重置表单数据
  title.value = '新增'
  dialogOpen.value = true
}

// 修改
const handleUpdate = (row) => {
  dialogReset() // 重置表单数据
  dialogFormData.value = {...row}
  dialogOpen.value = true // 显示对话框
}

// 删除
const handleDelete = async (row) => {
  if (row.children && row.children.length > 0) {
    warnMsg('包含子节点，无法进行删除，如必须删除，请先删除子节点')
  } else {
    confirmBox('是否确定要删除').then(async () => {
      await removePermission(row).then(resData => {
        if (resData.status === 1) {
          handleQuery()
          succesMsg('删除成功')
        }
      })
    }).catch(err => {
    })

  }

}

// 添加许可对话框
// 对话框参数
const title = ref('')
// 表单
const dialogFormRef = ref(null)
// 对话框form 值
const dialogFormData = ref({})
// 校验规则
const dialogFormRules = {
  permissionName: [
    {
      required: true,
      message: '名称不能为空',
      trigger: 'blur'
    }
  ],
  permissionCode: [
    {
      required: true,
      message: '编码不能为空',
      trigger: 'blur'
    }
  ]
}
// 是否显示对话框
const dialogOpen = ref(false)

// 重置对话框表单数据
const dialogReset = () => {
  dialogFormData.value = {}
  dialogFormData.value.permissionId = undefined        // 机构主键
  dialogFormData.value.permissionCode = undefined      // 编码
  dialogFormData.value.permissionDesc = undefined      // 描述
  dialogFormData.value.permissionName = undefined      // 名称
  // dialogFormData.value.type = 'M'      // 类型
}

// 关闭
const closed = () => {
  // 重置数据
  dialogFormRef.value.resetFields()
  dialogOpen.value = false
}

// 提交
const onConfirm = async () => {
  dialogFormRef.value.validate(async valid => {
    // 不合规直接返回
    if (!valid) return

    let resStatus = false
    // 修改
    if (dialogFormData.value.permissionId) {
      await modifyPermission(dialogFormData.value).then(resData => {
        if (resData.status === 1) {
          resStatus = true
        }
      })
    } else {
      await savePermission(dialogFormData.value).then(resData => {
        if (resData.status === 1) {
          resStatus = true
        }
      })
    }

    if (resStatus) {
      closed()
      handleQuery()
    }
  })

}

// 分配权限对话框
// 参数
const distributeDialogTitle = ref('')
const distributeDialogOpen = ref(false)
const distributeDataForm = ref({})
const operationOptions = ref([])
const operationTreeRef = ref(null)
const distributeProps = {
  children: 'children',
  label: 'operationName'
}

// 重置分配表单信息
const resetDistributeDataForm = () => {
  distributeDataForm.value.permissionId = '';
  distributeDataForm.value.permissionName = '';
  distributeDataForm.value.operationId = '';

}

// 获取所有操作
const getAllOperation = async () => {
  operationOptions.value = await store.getAllOperations()
}


// 分配权限
const handleDistribution = async (row) => {
  // resetDistributeDataForm() // 重置数据
  getAllOperation() // 获取所有操作
  distributeDataForm.value.permissionId = row.permissionId
  distributeDataForm.value.permissionName = row.permissionName
  // 获取当前许可下所有操作
  await getOperation({
    permissionId: row.permissionId
  }).then(resData => {
    store.getCheckedOperations(resData.data.map(operaItem => operaItem.operationId)).then(resData1 => {
      operationTreeRef.value.setCheckedKeys(resData1, false)

    })
  })
  distributeDialogOpen.value = true


}

// 关闭分配权限
const closedDistribute = () => {
  distributeDialogOpen.value = false
}

// 提交权限
const onConfirmDistribute = async () => {
  // 半选中节点
  const halfCheckedKeys = operationTreeRef.value.getHalfCheckedKeys()
  // 全选中节点
  const checkedKeys = operationTreeRef.value.getCheckedKeys(false)
  let operationIds = joinComma('', halfCheckedKeys)
  operationIds = joinComma(operationIds, checkedKeys)
  distributeDataForm.value.operationId = operationIds

  await addOperation(distributeDataForm.value).then(resData => {
    if (resData.status === 1) {
      closedDistribute()
    }
  })
}

</script>

<style lang="scss" scoped>
.peimission-container {
  padding: 10px;
  .el-scrollbar {
    margin-top: 10px;
  }
}

.app-container {
  :deep(.el-col) {
    margin-left: 5px;
  }
}
:deep(.el-form-item__content){
  display:block !important;
}

</style>